import * as wellknown from "wellknown";

// Interface for lightweight place data used for search
export interface SearchablePlaceItem {
  id: number | string;
  name: string;
  description?: string;
  thumbnail?: string;
  type?: string;
  label?: string;
  _title?: string;
  title?: string;
  [key: string]: any; // Allow for additional properties
}

export const checkValidGeojsonAndSupportedType = (geoJson: Record<string, any> | null) => {
  if (!geoJson || typeof geoJson !== "object" || !geoJson?.type) return null;

  const supportedTypes = ["Point", "LineString", "Polygon", "MultiPoint", "MultiLineString", "MultiPolygon", "GeometryCollection"];
  if (!supportedTypes.includes(geoJson?.type)) {
    return null;
  }

  // Validate coordinates exist and are not empty
  if (!geoJson.coordinates) {
    return null;
  }
  if (Array.isArray(geoJson.coordinates) && geoJson.coordinates.length === 0) {
    return null;
  }

  return geoJson;
};

/**
 * Parse WKT (Well-Known Text) format to GeoJSON using wellknown library
 */
export const wktToGeoJSON = (wktString: string) => {
  // NEW: Defensive check - only process strings
  if (typeof wktString !== "string") {
    console.warn("[WKT-PARSER] wktToGeoJSON called with non-string input:", typeof wktString);
    return null;
  }
  if (!wktString.trim()) {
    return null;
  }

  try {
    const geoJson = wellknown.parse(wktString);

    // Check if we got valid geojson and supported geometry types
    if (!checkValidGeojsonAndSupportedType(geoJson)) {
      console.warn("[WKT-PARSER] Unsupported geometry type:", geoJson?.type, "for WKT:", wktString);
      return null;
    }

    return geoJson;
  } catch (error) {
    // Handle "Unknown Geometry Type" and other WKT parsing errors gracefully
    if (error instanceof Error && error.message.includes("Unknown Geometry Type")) {
      console.warn("[WKT-PARSER] Unknown geometry type in WKT string:", wktString, "Error:", error.message);
    } else {
      console.error("[WKT-PARSER] WKT parsing error with wellknown library:", error, "WKT:", wktString);
    }

    // Return null instead of throwing - let the caller handle the fallback
    return null;
  }
};
